import React from 'react';
import AppImage from '@/components/ui/AppImage';

const MEMORIES = [
{
  id: 'mem-001',
  date: 'June 15, 2026',
  title: 'Summer Beach Adventure',
  type: 'Vacation',
  typeColor: 'bg-blue-50 text-blue-700 border-blue-200',
  description: 'Biscuit discovered the ocean for the first time and absolutely loved chasing the waves. She made three new dog friends and found a very special stick.',
  photos: [
  { src: "https://images.unsplash.com/photo-1705668738469-1498891133ae", alt: 'Golden retriever running on beach with waves in background' },
  { src: "https://images.unsplash.com/photo-1597067135728-8c16ae71ff71", alt: 'Golden retriever sitting on sandy beach looking at ocean' }]

},
{
  id: 'mem-002',
  date: 'May 3, 2026',
  title: '7th Birthday Celebration',
  type: 'Birthday',
  typeColor: 'bg-pink-50 text-pink-700 border-pink-200',
  description: 'Biscuit turned 7 today! We threw her a backyard birthday party with all her doggy friends. She got a special peanut butter cake and opened three presents.',
  photos: [
  { src: "https://images.unsplash.com/flagged/photo-1583958211970-af3e1596ef32", alt: 'Golden retriever with party hat sitting next to birthday cake with candles' }]

},
{
  id: 'mem-003',
  date: 'March 22, 2026',
  title: 'Agility Class Graduate',
  type: 'Achievement',
  typeColor: 'bg-amber-50 text-amber-700 border-amber-200',
  description: 'After 8 weeks of training, Biscuit graduated from her agility class with flying colors. She completed the full obstacle course in under 45 seconds!',
  photos: [
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_158df800d-1772987912269.png", alt: 'Golden retriever jumping over agility hurdle in training course' },
  { src: "https://images.unsplash.com/photo-1590180581630-6bf0ed757cab", alt: 'Dog with graduation ribbon sitting proudly' }]

},
{
  id: 'mem-004',
  date: 'December 25, 2025',
  title: 'First Christmas with Baby Emma',
  type: 'Family',
  typeColor: 'bg-green-50 text-green-700 border-green-200',
  description: 'The most magical Christmas yet — Biscuit met our new baby Emma and was the most gentle, loving dog. She sat beside the crib all morning.',
  photos: [
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_12e23901e-1772560442265.png", alt: 'Golden retriever sitting by Christmas tree with wrapped presents' }]

},
{
  id: 'mem-005',
  date: 'August 10, 2025',
  title: 'Puppy Years Memory — First Day Home',
  type: 'Puppy Years',
  typeColor: 'bg-violet-50 text-violet-700 border-violet-200',
  description: 'A throwback to the day we brought Biscuit home as a tiny 8-week-old puppy. She fit in the palm of my hand and cried for exactly one night before deciding she owned the house.',
  photos: [
  { src: "https://images.unsplash.com/photo-1518914781460-a3ada465edec", alt: 'Tiny golden retriever puppy sleeping in owner hands' }]

}];


export default function DogMemoryTimeline() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl font-700 text-foreground">Memory Timeline</h2>
        <span className="text-sm text-muted-foreground">47 memories preserved</span>
      </div>
      {MEMORIES?.map((memory) =>
      <div key={memory?.id} className="bg-card border border-border rounded-2xl overflow-hidden shadow-card card-hover">
          {/* Photos */}
          {memory?.photos?.length > 0 &&
        <div className={`grid gap-1 ${memory?.photos?.length > 1 ? 'grid-cols-2' : 'grid-cols-1'}`}>
              {memory?.photos?.map((photo, pi) =>
          <div key={`${memory?.id}-photo-${pi}`} className="relative h-52 bg-muted overflow-hidden">
                  <AppImage
              src={photo?.src}
              alt={photo?.alt}
              fill
              className="object-cover"
              sizes="(max-width: 768px) 100vw, 50vw" />
            
                </div>
          )}
            </div>
        }
          {/* Content */}
          <div className="p-5">
            <div className="flex items-start justify-between gap-3 mb-2">
              <h3 className="font-700 text-base text-foreground">{memory?.title}</h3>
              <span className={`shrink-0 text-xs font-600 px-2.5 py-1 rounded-full border ${memory?.typeColor}`}>
                {memory?.type}
              </span>
            </div>
            <p className="text-xs text-muted-foreground font-500 mb-2">{memory?.date}</p>
            <p className="text-sm text-foreground/80 leading-relaxed">{memory?.description}</p>
          </div>
        </div>
      )}
      <button className="w-full py-3 border border-dashed border-border rounded-xl text-sm font-600 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors">
        Load 42 more memories
      </button>
    </div>);

}